var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 224,
    viewBox: "0 0 408 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M393.23 197.916H364.771C362.139 197.916 360.005 200.046 360.005 202.675V221C360.005 222.196 360.975 223.164 362.172 223.164H395.83C397.027 223.164 397.997 222.196 397.997 221V202.675C397.997 200.046 395.863 197.916 393.23 197.916Z",
    fill: "#939598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83616 222.793C5.73086 222.793 5.62556 222.771 5.52026 222.733C5.14893 222.583 4.93833 222.185 5.02146 221.792L6.30725 215.731C6.31833 215.682 6.33496 215.632 6.35159 215.587L12.0767 201.674C12.2097 201.353 12.5201 201.159 12.847 201.159C12.9523 201.159 13.0576 201.181 13.1629 201.22L15.2357 202.067C15.4408 202.15 15.6015 202.31 15.6847 202.515C15.7678 202.72 15.7678 202.947 15.6847 203.151L9.95956 217.065C9.94293 217.11 9.91522 217.154 9.88751 217.198L6.53448 222.412C6.3793 222.655 6.10773 222.793 5.83616 222.793Z",
    fill: "#B2CFD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8471 201.983L14.9199 202.83L9.1948 216.744L5.84177 221.958L7.12756 215.897L12.8471 201.983ZM12.8471 200.323C12.1931 200.323 11.5724 200.711 11.3064 201.353L5.58128 215.266C5.54249 215.36 5.51478 215.455 5.49261 215.554L4.20682 221.615C4.04055 222.4 4.45622 223.192 5.19887 223.496C5.40393 223.579 5.62008 223.624 5.83068 223.624C6.3849 223.624 6.91695 223.347 7.22732 222.86L10.5803 217.646C10.6358 217.563 10.6801 217.475 10.7189 217.381L16.444 203.467C16.6103 203.057 16.6103 202.603 16.4384 202.194C16.2666 201.79 15.9452 201.463 15.5351 201.297L13.4623 200.45C13.2683 200.362 13.0577 200.323 12.8471 200.323Z",
    fill: "#5F7582"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6721 214.215C11.3395 215.449 10.0704 216.18 8.82893 215.848C7.59302 215.516 6.86145 214.248 7.19399 213.014L21.3654 177.681C21.6979 176.447 22.9671 175.711 24.2085 176.043C25.4444 176.375 26.1816 177.648 25.849 178.882L11.6721 214.215Z",
    fill: "white",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3426 221.653C64.6276 221.653 63.9847 221.227 63.7076 220.563L57.1401 204.734C56.9572 204.297 56.9572 203.821 57.1401 203.384C57.323 202.946 57.6611 202.609 58.0989 202.426C58.315 202.338 58.5423 202.293 58.7751 202.293C59.49 202.293 60.1329 202.72 60.41 203.384L66.9775 219.212C67.1604 219.65 67.1604 220.126 66.9775 220.563C66.7946 221 66.4565 221.338 66.0187 221.52C65.8026 221.609 65.5753 221.653 65.3426 221.653Z",
    fill: "#B2CFD8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7806 203.124C59.1464 203.124 59.4956 203.339 59.6452 203.699L66.2127 219.528C66.4122 220.004 66.185 220.552 65.7028 220.751C65.5864 220.801 65.4645 220.823 65.3426 220.823C64.9768 220.823 64.6276 220.607 64.478 220.247L57.9105 204.424C57.711 203.948 57.9382 203.4 58.4148 203.201C58.5368 203.146 58.6587 203.124 58.7806 203.124ZM58.7806 201.463C58.437 201.463 58.1045 201.53 57.7886 201.657C57.1401 201.923 56.6413 202.426 56.3753 203.063C56.1093 203.705 56.1093 204.408 56.3753 205.05L62.9428 220.873C63.3474 221.847 64.2896 222.478 65.3426 222.478C65.6862 222.478 66.0187 222.411 66.3346 222.279C66.9775 222.013 67.4763 221.515 67.7479 220.873C68.0139 220.231 68.0139 219.522 67.7479 218.886L61.1804 203.063C60.7758 202.089 59.8336 201.463 58.7806 201.463Z",
    fill: "#5F7582"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.266 214.215C60.5986 215.449 61.8733 216.18 63.1092 215.848C64.3451 215.516 65.0767 214.248 64.7497 213.014L50.5783 177.681C50.2458 176.447 48.9766 175.711 47.7351 176.043C46.4992 176.375 45.7621 177.648 46.1002 178.882L60.266 214.215Z",
    fill: "white",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1937 194.589C20.6616 196.576 18.6055 197.761 16.6103 197.224C14.6151 196.687 13.4401 194.639 13.9722 192.652L32.4942 146.245C33.0318 144.252 35.0769 143.074 37.0721 143.61C39.0673 144.147 40.2478 146.195 39.7157 148.187L21.1937 194.589Z",
    fill: "#FFECB4",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.088 194.589C51.6256 196.576 53.6762 197.761 55.6659 197.224C57.6611 196.687 58.8416 194.639 58.304 192.652L39.7875 146.245C39.2499 144.252 37.1993 143.074 35.2041 143.61C33.2144 144.147 32.0284 146.195 32.566 148.187L51.088 194.589Z",
    fill: "#FFECB4",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3839 193.626C57.3839 195.115 56.1757 196.321 54.6849 196.321C53.194 196.321 51.9858 195.115 51.9858 193.626C51.9858 192.137 53.194 190.931 54.6849 190.931C56.1757 190.931 57.3839 192.137 57.3839 193.626Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3592 193.626C56.3592 194.545 55.611 195.298 54.6855 195.298C53.7599 195.298 53.0117 194.551 53.0117 193.626C53.0117 192.702 53.7599 191.955 54.6855 191.955C55.611 191.955 56.3592 192.702 56.3592 193.626Z",
    fill: "#FFA4A9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3127 193.554C20.3127 195.043 19.1045 196.25 17.6136 196.25C16.1228 196.25 14.9146 195.043 14.9146 193.554C14.9146 192.066 16.1228 190.859 17.6136 190.859C19.1045 190.859 20.3127 192.066 20.3127 193.554Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2873 193.554C19.2873 194.473 18.5391 195.226 17.6135 195.226C16.6935 195.226 15.9453 194.479 15.9453 193.554C15.9453 192.63 16.6935 191.883 17.6135 191.883C18.5391 191.883 19.2873 192.63 19.2873 193.554Z",
    fill: "#FFA4A9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8179 145.249C38.8179 146.771 37.582 148.005 36.0579 148.005C34.5338 148.005 33.2979 146.771 33.2979 145.249V130.449C33.2979 128.927 34.5338 127.693 36.0579 127.693C37.582 127.693 38.8179 128.927 38.8179 130.449V145.249Z",
    fill: "#A9CD68",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0796 147.595C43.0796 151.47 39.9371 154.602 36.0576 154.602C32.1781 154.602 29.0356 151.464 29.0356 147.595C29.0356 143.727 32.1781 140.589 36.0576 140.589C39.9371 140.589 43.0796 143.727 43.0796 147.595Z",
    fill: "white",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4364 147.595C40.4364 150.014 38.4744 151.968 36.058 151.968C33.6416 151.968 31.6797 150.008 31.6797 147.595C31.6797 145.182 33.6416 143.223 36.058 143.223C38.48 143.223 40.4364 145.182 40.4364 147.595Z",
    fill: "#FFA4A9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M296.867 42.6326V222.849H316.825V42.6326L312.629 39.5001L296.867 42.6326Z",
    fill: "#939598"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M291.73 222.998C291.27 222.998 290.898 222.628 290.898 222.168V40.9392C290.898 40.4798 291.27 40.109 291.73 40.109H311.715C312.175 40.109 312.546 40.4798 312.546 40.9392V222.168C312.546 222.628 312.175 222.998 311.715 222.998H291.73Z",
    fill: "#FFECB4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M311.715 40.9391V222.168H291.73V40.9391H311.715ZM311.715 39.2732H291.73C290.81 39.2732 290.067 40.0148 290.067 40.9336V222.163C290.067 223.081 290.816 223.823 291.73 223.823H311.715C312.635 223.823 313.378 223.081 313.378 222.163V40.9391C313.383 40.0204 312.635 39.2732 311.715 39.2732Z",
    fill: "#5F7582"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M307.376 49.6672H311.887",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M304.6 58.8434H311.888",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M307.376 68.0197H311.887",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M304.6 77.1959H311.888",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M307.376 86.3724H311.887",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M304.6 95.5487H311.888",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M307.376 104.725H311.887",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M304.6 113.901H311.888",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M307.376 123.083H311.887",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M304.6 132.259H311.888",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M307.376 141.436H311.887",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M304.6 150.606H311.888",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M307.376 159.788H311.887",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M304.6 168.965H311.888",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M307.376 178.141H311.887",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M304.6 187.317H311.888",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M307.376 196.493H311.887",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M304.6 205.874H311.888",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M307.376 215.051H311.887",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6104 141.635V223.164H17.9683L99.6104 141.635ZM87.5727 211.149V170.663L47.026 211.149H87.5727Z",
    fill: "#FFA4A9",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0425 215.87V223.153",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8481 218.643V223.153",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6592 215.87V223.153",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4702 218.643V223.153",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2812 215.87V223.153",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0923 218.643V223.153",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6982 215.87V223.153",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5093 218.643V223.153",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M285.479 89.5879C278.346 89.5879 279.438 94.89 279.438 102.013V210.241C279.438 217.37 285.241 223.164 292.379 223.164H302.383C309.288 221.233 314.043 216.672 314.043 208.481V204.363H300.41V98.9966C300.41 93.7997 296.192 89.5824 290.982 89.5824H285.479V89.5879Z",
    fill: "#939598"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M107.219 98.5208C107.219 93.584 111.226 89.588 116.165 89.588H285.556C290.494 89.588 294.501 93.5895 294.501 98.5208V204.436H107.214L107.219 98.5208Z",
    fill: "#EFEFEF",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4004 204.441V208.31C94.4004 219.08 103.14 223.164 113.926 223.164H287.784C298.569 223.164 307.309 219.08 307.309 208.31V204.441H94.4004Z",
    fill: "#EFEFEF",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M283.811 103.939H120.116V198.115H283.811V103.939Z",
    fill: "#B2CFD8",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M183.951 119.917H173.321V130.532H183.951V119.917Z",
    fill: "#FFECB4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M160.929 119.917H150.299V130.532H160.929V119.917Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M198.876 119.917H188.246V130.532H198.876V119.917Z",
    fill: "#FFA4A9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M213.807 119.917H203.177V130.532H213.807V119.917Z",
    fill: "#FFECB4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M283.8 103.939H120.122V198.109H283.8V103.939Z",
    stroke: "#5F7582",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M407.169 223.164H0.831543",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M283.81 144.048H120.11V182.79H283.81V144.048Z",
    fill: "white",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M247.493 150.285H236.408V161.354H247.493V150.285Z",
    fill: "#FFA4A9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M247.493 165.489H236.408V176.558H247.493V165.489Z",
    fill: "#FFECB4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M323.803 223.159V123.537H341.432V130.483C362.005 134.65 376.864 152.748 376.864 173.774C376.864 194.8 362.005 212.898 341.432 217.065V223.159H323.803ZM341.432 198.851C351.968 195.143 359.228 184.992 359.228 173.779C359.228 162.566 351.963 152.416 341.432 148.702V198.851Z",
    fill: "#A9CD68"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M340.601 124.367V131.169C360.736 134.927 376.033 152.593 376.033 173.774C376.033 194.955 360.736 212.627 340.601 216.379V222.323H324.634V124.367H340.601ZM340.601 199.997C351.852 196.576 360.06 186.116 360.06 173.774C360.06 161.432 351.852 150.977 340.601 147.551V199.997ZM342.264 122.707H340.601H324.634H322.972V124.367V222.323V223.983H324.634H340.601H342.264V222.323V217.735C362.875 213.241 377.695 194.966 377.695 173.774C377.695 152.577 362.875 134.307 342.264 129.807V124.367V122.707ZM342.264 197.644V149.898C351.869 153.794 358.397 163.303 358.397 173.768C358.397 184.24 351.869 193.748 342.264 197.644Z",
    fill: "#5F7582"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M329.084 132.054H324.567",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M331.861 141.231H324.567",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M329.084 150.407H324.567",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M331.861 159.583H324.567",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M329.084 168.76H324.567",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M331.861 177.936H324.567",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M329.084 187.112H324.567",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M331.861 196.288H324.567",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M329.084 205.465H324.567",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M331.861 214.641H324.567",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M344.393 138.015L346.648 131.092",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M354.768 143.295L359.052 137.401",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M362.998 151.514L368.895 147.23",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M368.279 161.869L375.213 159.617",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M370.103 173.348H377.391",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M368.279 184.827L375.213 187.079",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M362.998 195.182L368.895 199.465",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M354.768 203.401L359.052 209.295",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M344.393 208.68L346.648 215.604",
    stroke: "#5F7582",
    strokeWidth: 3.0039
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6796 222.661C82.2577 222.661 80.2847 220.69 80.2847 218.272C80.2847 215.853 82.2577 213.883 84.6796 213.883C87.1016 213.883 89.0746 215.853 89.0746 218.272C89.069 220.69 87.1016 222.661 84.6796 222.661Z",
    fill: "#FFA4A9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6794 214.713C86.6469 214.713 88.243 216.307 88.243 218.272C88.243 220.236 86.6469 221.83 84.6794 221.83C82.7119 221.83 81.1158 220.236 81.1158 218.272C81.1158 216.307 82.7119 214.713 84.6794 214.713ZM84.6794 213.053C81.7975 213.053 79.4531 215.394 79.4531 218.272C79.4531 221.15 81.7975 223.491 84.6794 223.491C87.5614 223.491 89.9057 221.15 89.9057 218.272C89.9002 215.394 87.5614 213.053 84.6794 213.053Z",
    fill: "#5F7582"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0804 111.914H80.2461V216.262H89.0804V111.914Z",
    fill: "#B2CFD8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2488 112.744V215.432H81.0772V112.744H88.2488ZM89.9115 111.084H88.2488H81.0772H79.4146V112.744V215.432V217.093H81.0772H88.2488H89.9115V215.432V112.744V111.084Z",
    fill: "#5F7582"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0718 112.346C80.7338 112.346 80.4345 112.141 80.3015 111.831C80.174 111.521 80.246 111.161 80.4844 110.923L84.0979 107.326C84.2531 107.171 84.4637 107.082 84.6853 107.082C84.6853 107.082 84.6853 107.082 84.6909 107.082C84.9126 107.082 85.1232 107.171 85.2784 107.331L88.842 110.929C89.0803 111.167 89.1468 111.521 89.0193 111.831C88.8919 112.141 88.587 112.34 88.2545 112.34H81.0718V112.346Z",
    fill: "#F6DC8C"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6852 107.918L88.2488 111.516H84.6852H84.6298H81.0661L84.6852 107.918ZM84.6852 106.258C84.2474 106.258 83.8206 106.429 83.5103 106.745L79.8967 110.342C79.4201 110.818 79.276 111.532 79.5365 112.152C79.7914 112.772 80.4011 113.176 81.0717 113.176H84.6353H84.6907H88.2544C88.925 113.176 89.5291 112.772 89.7896 112.158C90.0501 111.538 89.9115 110.829 89.4404 110.348L85.8768 106.75C85.5664 106.435 85.1452 106.258 84.7018 106.258C84.6907 106.258 84.6907 106.258 84.6852 106.258Z",
    fill: "#5F7582"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8825 109.075H83.4883L84.6854 107.874L85.8825 109.075Z",
    fill: "#284356",
    stroke: "#5F7582",
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0774 219.102C80.6174 219.102 80.2461 218.731 80.2461 218.272V215.433C80.2461 214.973 80.6174 214.602 81.0774 214.602H88.249C88.709 214.602 89.0804 214.973 89.0804 215.433V218.272C89.0804 218.731 88.709 219.102 88.249 219.102H81.0774Z",
    fill: "#F6DC8C"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2488 215.433V218.272H81.0772V215.433H88.2488ZM88.2488 213.772H81.0772C80.1572 213.772 79.4146 214.514 79.4146 215.433V218.272C79.4146 219.19 80.1572 219.932 81.0772 219.932H88.2488C89.1688 219.932 89.9115 219.19 89.9115 218.272V215.433C89.9115 214.514 89.1688 213.772 88.2488 213.772Z",
    fill: "#5F7582"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M386.918 198.729H359.378C356.829 198.729 354.762 200.794 354.762 203.334V221.067C354.762 222.223 355.704 223.159 356.857 223.159H389.428C390.586 223.159 391.529 222.223 391.529 221.067V203.34C391.534 200.794 389.467 198.729 386.918 198.729Z",
    fill: "#FFA4A9",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M386.851 214.193C386.851 216.855 384.69 219.008 382.03 219.008C379.364 219.008 377.208 216.855 377.208 214.193C377.208 211.536 379.369 209.378 382.03 209.378C384.69 209.378 386.851 211.536 386.851 214.193Z",
    fill: "#5F7582"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M367.21 214.193C367.21 216.274 365.519 217.962 363.435 217.962C361.351 217.962 359.661 216.274 359.661 214.193C359.661 212.112 361.351 210.424 363.435 210.424C365.514 210.424 367.21 212.112 367.21 214.193Z",
    fill: "#5F7582"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M354.768 205.858H391.535",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M180.344 4.78748H179.79",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M178.703 4.78748H133.601",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "1.96 1.96"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M133.052 4.78748H132.498",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M349.374 8.57855H297.012",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M270.792 69.121H248.673",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M311.372 0.8302H289.253",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M382.866 39.5721H360.747",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M70.519 17.5391L74.4429 21.4575L82.5512 13.366",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M239.09 72.7351L231.774 65.4351",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M231.774 72.7351L239.09 65.4351",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M105.878 49.7889H155.891",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M140.279 57.6867H162.398",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M170.24 57.6867H180.826",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M106.81 41.9022H128.928",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M381.803 111.577C381.803 113.32 380.378 114.737 378.632 114.737C376.887 114.737 375.468 113.32 375.468 111.577C375.468 109.828 376.887 108.411 378.632 108.411C380.378 108.411 381.803 109.828 381.803 111.577Z",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M192.248 4.79298C192.248 6.53636 190.823 7.95321 189.078 7.95321C187.332 7.95321 185.913 6.53636 185.913 4.79298C185.913 3.04406 187.332 1.62721 189.078 1.62721C190.823 1.62168 192.248 3.03852 192.248 4.79298Z",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M232.512 103.95V198.037",
    stroke: "#5F7582",
    strokeWidth: 2.8377,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M251.633 103.95V198.037",
    stroke: "#5F7582",
    strokeWidth: 2.8377,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M160.929 150.28H150.299V160.895H160.929V150.28Z",
    fill: "#A9CD68"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M202.246 150.263H173.321V154.314H202.246V150.263Z",
    fill: "#FFECB4"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M202.246 157.674H173.321V161.731H202.246V157.674Z",
    fill: "#FFECB4"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M202.246 165.09H173.321V169.141H202.246V165.09Z",
    fill: "#FFECB4"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M202.246 172.501H173.321V176.558H202.246V172.501Z",
    fill: "#FFECB4"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M167.114 103.585V198.037",
    stroke: "#5F7582",
    strokeWidth: 2.8433,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M144.114 103.585V198.037",
    stroke: "#5F7582",
    strokeWidth: 2.8433,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M242.582 26.2781C244.966 26.2781 246.905 28.2097 246.905 30.5951C246.905 32.9749 244.971 34.912 242.582 34.912C240.792 34.912 239.257 33.8272 238.603 32.2776H234.535C233.881 33.8272 232.346 34.912 230.556 34.912C228.766 34.912 227.231 33.8272 226.577 32.2776H222.509C221.855 33.8272 220.319 34.912 218.529 34.912C216.141 34.912 214.206 32.9804 214.206 30.5951C214.206 28.2097 216.141 26.2781 218.529 26.2781C220.319 26.2781 221.855 27.3629 222.509 28.9126H226.577C227.231 27.3629 228.766 26.2781 230.556 26.2781C232.346 26.2781 233.881 27.3629 234.535 28.9126H238.603C239.257 27.3629 240.792 26.2781 242.582 26.2781ZM242.582 24.6177C240.565 24.6177 238.714 25.625 237.617 27.2522H235.511C234.413 25.6195 232.568 24.6177 230.545 24.6177C228.522 24.6177 226.676 25.625 225.579 27.2522H223.473C222.376 25.6195 220.53 24.6177 218.507 24.6177C215.209 24.6177 212.521 27.2965 212.521 30.5951C212.521 33.8881 215.204 36.5724 218.507 36.5724C220.524 36.5724 222.37 35.5651 223.467 33.9379H225.573C226.671 35.5651 228.516 36.5724 230.534 36.5724C232.551 36.5724 234.397 35.5651 235.494 33.9379H237.6C238.697 35.5651 240.543 36.5724 242.56 36.5724C245.858 36.5724 248.546 33.8936 248.546 30.5951C248.568 27.302 245.88 24.6177 242.582 24.6177Z",
    fill: "#5F7582"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1462 84.1694C73.2404 84.2414 73.3346 84.2801 73.451 84.1196L75.3077 81.5848C75.352 81.5239 75.352 81.4575 75.3464 81.4243C75.3409 81.3911 75.3243 81.3302 75.2578 81.2804L73.4067 79.9299L73.6117 79.5038C74.105 78.4854 74.4542 77.4062 74.6592 76.3104L74.7424 75.8454L77.0424 75.851C77.1643 75.851 77.2585 75.7514 77.2585 75.6351L77.2641 72.497C77.2641 72.4196 77.2253 72.3698 77.2031 72.3421C77.1809 72.3199 77.1255 72.2757 77.0479 72.2757L74.7424 72.2701L74.6592 71.8052C74.5539 71.2407 74.4264 70.7205 74.2602 70.2113C74.0939 69.7021 73.8889 69.1874 73.6173 68.6229L73.4122 68.1967L75.2966 66.8352C75.3963 66.7632 75.4185 66.6249 75.3464 66.5308L73.5064 63.9849C73.3901 63.8244 73.3014 63.8687 73.2016 63.9351L71.3173 65.2966L70.9737 64.97C70.1645 64.2007 69.2556 63.5366 68.2691 63.0053L67.8534 62.7784L68.5794 60.5645C68.6182 60.4483 68.5573 60.3266 68.4409 60.2878L65.3816 59.2971C65.304 59.2971 65.2098 59.3414 65.1765 59.4466L64.4449 61.6715L63.9794 61.6106C62.7767 61.4501 61.8457 61.4445 60.643 61.605L60.1719 61.6659L59.4514 59.4355C59.4182 59.3303 59.324 59.2861 59.1743 59.2916L56.1815 60.2546C56.1039 60.2768 56.0707 60.3321 56.0541 60.3653C56.0374 60.393 56.0153 60.4594 56.043 60.5313L56.7579 62.7507L56.3423 62.9721C55.3502 63.5034 54.4357 64.1565 53.6266 64.9202L53.283 65.2468L51.4042 63.8742C51.3044 63.8023 51.2157 63.7635 51.0993 63.924L49.2427 66.4588C49.1707 66.5585 49.1928 66.6913 49.287 66.7632L51.1658 68.1358L50.9552 68.562C50.462 69.5748 50.1017 70.643 49.8967 71.7388L49.808 72.2037L47.5025 72.1982C47.3861 72.1982 47.2863 72.2978 47.2863 72.414L47.2808 75.5521C47.2808 75.6296 47.3196 75.6794 47.3417 75.7071C47.3639 75.7292 47.4138 75.7735 47.4969 75.7735L49.7914 75.779L49.8745 76.2439C49.9743 76.8195 50.1128 77.3841 50.2846 77.9154C50.4398 78.3969 50.6449 78.9005 50.8998 79.4484L51.0993 79.8746L49.2427 81.214C49.1817 81.2582 49.1596 81.3247 49.154 81.3579C49.1485 81.3911 49.1485 81.4575 49.1928 81.5184L51.0328 84.0643C51.0938 84.1473 51.1769 84.1528 51.2102 84.1528C51.2434 84.1528 51.2933 84.1473 51.3376 84.1141L53.1777 82.7858L53.5213 83.1178C54.336 83.9038 55.2504 84.5734 56.248 85.1158L56.6637 85.3427L55.9598 87.4902C55.921 87.6064 55.982 87.7281 56.0984 87.7669L59.1522 88.7576C59.2297 88.7576 59.3295 88.7133 59.3628 88.6081L60.0666 86.4607L60.5377 86.5216C61.7514 86.6876 62.6936 86.6932 63.9184 86.5271L64.3895 86.4663L65.0823 88.6247C65.1156 88.7299 65.2098 88.7742 65.2929 88.7742L68.3522 87.8001C68.4686 87.7613 68.5295 87.6396 68.4963 87.5234L67.8035 85.3649L68.2192 85.1435C69.2223 84.6066 70.1423 83.937 70.957 83.1621L71.3006 82.8356L73.1462 84.1694ZM55.3447 74.1685C55.3447 70.3386 58.4649 67.2226 62.3001 67.2226C66.1353 67.2226 69.2556 70.3386 69.2556 74.1685C69.2556 77.9984 66.1353 81.1088 62.3001 81.1088C58.4649 81.1088 55.3447 77.9984 55.3447 74.1685Z",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6765 53.3918C83.538 53.2921 83.4825 53.1095 83.5213 52.9435C83.61 52.5284 83.6599 52.0967 83.6599 51.6484C83.6599 51.2056 83.61 50.7739 83.5213 50.3533C83.4825 50.1873 83.538 50.0046 83.6765 49.905L85.6163 48.4992C85.7382 48.4107 85.7659 48.2336 85.6773 48.1118L83.3994 44.9792C83.3107 44.8575 83.1334 44.8298 83.0115 44.9184L81.1382 46.2743C80.9941 46.3795 80.8057 46.3629 80.656 46.2688C79.8912 45.7928 79.0155 45.4829 78.0734 45.3722C77.9016 45.3501 77.7464 45.2449 77.6965 45.0789L77.0093 42.9702C76.9649 42.8263 76.8042 42.7433 76.6601 42.7931L72.969 43.9886C72.8249 44.0328 72.7418 44.1933 72.7916 44.3372L73.4401 46.3297C73.4844 46.4736 73.4678 46.6341 73.3459 46.7282C72.5533 47.3646 71.9215 48.1893 71.5114 49.1357C71.4394 49.3017 71.2953 49.4346 71.1124 49.4346H69.0784C68.9232 49.4346 68.8013 49.5563 68.8013 49.7113V53.5855C68.8013 53.7404 68.9232 53.8622 69.0784 53.8622H71.1124C71.262 53.8622 71.4172 53.9341 71.4726 54.0725C71.8661 55.0245 72.4924 55.8602 73.2738 56.5077C73.4124 56.6184 73.49 56.7955 73.4345 56.9671L72.7861 58.9595C72.7418 59.1034 72.8194 59.2584 72.9635 59.3082L76.6546 60.5037C76.7987 60.5479 76.9538 60.4705 77.0037 60.3266L77.6909 58.2179C77.7464 58.0463 77.9182 57.9467 78.1011 57.9246C79.0377 57.8083 79.9134 57.4929 80.6727 57.0169C80.8112 56.9283 80.9941 56.9283 81.1327 57.028L83.0059 58.3839C83.1279 58.4725 83.3052 58.4448 83.3939 58.323L85.6773 55.1905C85.7659 55.0687 85.7382 54.8916 85.6163 54.8031L83.6765 53.3918Z",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M77.27 54.0005C78.5709 54.0005 79.6254 52.9474 79.6254 51.6483C79.6254 50.3493 78.5709 49.2961 77.27 49.2961C75.9691 49.2961 74.9146 50.3493 74.9146 51.6483C74.9146 52.9474 75.9691 54.0005 77.27 54.0005Z",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M356.465 64.9418L343.615 77.7741L347.589 81.7424L360.439 68.9101L356.465 64.9418Z",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M345.362 79.8967L358.459 66.9293",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M361.927 67.4109C362.642 66.6969 362.654 65.5457 361.95 64.8484L360.52 63.4204C359.816 62.7175 358.669 62.7286 357.954 63.4426L356.463 64.9314L360.442 68.9052L361.927 67.4109Z",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M347.584 81.7287C347.584 81.7287 347.512 81.7564 347.407 81.7841L341.765 83.771C341.593 83.8429 341.493 83.7489 341.56 83.5718L343.555 77.932C343.588 77.8269 343.61 77.7605 343.61 77.7605L347.584 81.7287Z",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M362.909 86.7431H338.329",
    stroke: "#5F7582",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.c16e71058108c6485f0d6bcd32ba7fb4.svg";
export { ForwardRef as ReactComponent };